import React, { FunctionComponent } from 'react'
import Colors from '../../../tokens/Colors'
import { motion } from 'framer-motion'
import { rem } from '../../../utils/rem'
import styled from 'styled-components'
import { textAnimation } from './animations'

interface ScrollIndicatorProps {
  progress?: number
  text: string
}

const ScrollIndicator: FunctionComponent<ScrollIndicatorProps> = ({
  progress = 0,
  text,
}) => (
  <StyledScrollIndicator>
    <Text
      animate={progress < 100 ? 'opacityIn' : 'opacityOut'}
      exit="exit"
      variants={textAnimation}
    >
      {text}
    </Text>
    <Line
      animate={{
        opacity: 1,
        scaleY: 1 - progress / 100,
        transformOrigin: progress === 0 ? '0% 0%' : '0% 100%',
        transition: {
          duration: 0.6,
        },
      }}
      exit={{
        opacity: 0,
        scaleY: 0,
        transition: {
          duration: 0.3,
        },
      }}
    />
  </StyledScrollIndicator>
)

const StyledScrollIndicator = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

const Text = styled(motion.p)`
  font-size: ${rem(11)};
  font-weight: 700;
  line-height: ${rem(16)};
  color: ${Colors.WHITE};
  text-transform: uppercase;
  margin: 0 0 ${rem(16)};
`

const Line = styled(motion.div)`
  height: ${rem(50)};
  width: ${rem(1)};
  background-color: ${Colors.WHITE};
  transform-origin: 0 100%;
`

export default ScrollIndicator
